module.exports = __webpack_public_path__ + "img/pointer.d60be4ba.svg";